<template>
  <span>
    <span @click="isOpen = true" class="hand"><slot /></span>
    <HiDialog v-model="isOpen" :title="title"> {{ leadSources }}</HiDialog>
  </span>
</template>

<script>
import HiDialog from "@/components/HiDialog";
import { mapGetters } from "vuex";
export default {
  name: "DiSrc",
  components: { HiDialog },
  props: {
    doc: null
  },
  data() {
    return {
      isOpen: false,
      source: null,
      tag: null
    };
  },
  computed: {
    ...mapGetters("meta", ["leadSources"]),
    title() {
      if (this.doc) {
        return "Set Source for " + this.doc.name;
      } else {
        return "waiting...";
      }
    }
  }
};
</script>

<style scoped></style>
